import axios, { InternalAxiosRequestConfig } from 'axios'

const hostname = window && window.location && window.location.hostname;

let apiPath = '/';
let withCredentials = false;
if(hostname === 'localhost') {
    apiPath = 'http://localhost:8080/';
    withCredentials = true;
}

const instance = axios.create({
    baseURL: apiPath,
    withCredentials: withCredentials,
    headers: {
        'Content-Type': 'application/json'
    }
});

instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.set('X-Auth', token);
    } else {
        config.headers.set('X-Auth', '');
    }
    return config;
});

export default instance;